import { IconProps } from '../icon';

export function ProjectIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.3696 3.69995H9.62882C9.62882 3.69995 8.03522 3.69995 8.03522 5.29995H23.9632C23.9632 3.69995 22.3696 3.69995 22.3696 3.69995ZM27.1488 8.49995C27.1488 6.89995 25.5568 6.89995 25.5568 6.89995H6.44322C6.44322 6.89995 4.85122 6.89995 4.85122 8.49995V10.1H27.1488V8.49995ZM30.3328 10.1L29.392 9.15275V11.7H2.60802V9.15275L1.66562 10.1C0.723216 11.0472 0.0480161 11.3 0.427216 13.3C0.804816 15.2936 2.63362 26.2216 2.90562 27.7C3.20322 29.3224 4.85282 29.3 4.85282 29.3H27.1504C27.1504 29.3 28.7984 29.3224 29.0976 27.7C29.3696 26.2216 31.1968 15.2936 31.576 13.3C31.952 11.3 31.2768 11.0472 30.3328 10.1ZM22.4 19.6952C22.4 20.5816 21.6816 21.3 20.7952 21.3H11.2048C10.7792 21.3 10.371 21.1309 10.0701 20.8299C9.76909 20.529 9.60002 20.1208 9.60002 19.6952V16.5H11.2V19.7H20.8V16.5H22.4V19.6952Z"
        fill="#83B735"
      />
    </svg>
  );
}

export default ProjectIcon;
